import React from 'react';
import ReactDOM from 'react-dom';

import { colorSteps } from '../scripts/config.js';
import LatestWeek from '../scripts/LatestWeekNumber';
import Chart from '../scripts/Chart';

import './styles.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

ReactDOM.render(
  <LatestWeek colorSteps={colorSteps} />,
  document.getElementById('iframeteaser__lastweek')
);

ReactDOM.render(
  <Chart
    colorSteps={colorSteps}
    selector="#iframeteaser__chart"
    showBulletpoints={false}
    showTooltip={false}
    showLegend={false}
    isTeaser={true}
  />,
  document.getElementById('iframeteaser__chart')
);

if (process.env.NODE_ENV === 'development') {
  // enable livereload for index html
  require('file-loader!./index.html');
}
